
import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import HowItWorks from './components/HowItWorks';
import WhyPartner from './components/WhyPartner';
import IncludedFeatures from './components/IncludedFeatures';
import SampleIssue from './components/SampleIssue';
import WhyFree from './components/WhyFree';
import Compliance from './components/Compliance';
import FAQ from './components/FAQ';
import SignupForm from './components/SignupForm';

export default function HomePage() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <HowItWorks />
      <WhyPartner />
      <IncludedFeatures />
      <SampleIssue />
      <WhyFree />
      <Compliance />
      <FAQ />
      <SignupForm id="request-sample" />
      <Footer />

      {/* Scroll to top button - mobile only */}
      <button
        onClick={scrollToTop}
        className={`md:hidden fixed bottom-6 right-6 z-50 w-12 h-12 flex items-center justify-center bg-gradient-to-r from-[#6B4EFF] to-[#FF4D7D] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer ${
          showScrollTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
        aria-label="Scroll to top"
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </button>
    </div>
  );
}
